.subtitle {
  color: var(--paletteBlue2);
}
